import { Tag } from '@carbon/react';

// Shared labels of the lo de admin pages (P1-D10)

export const DRAW_STATE: Record<string, { text: string; tag: 'red' | 'green' | 'magenta' | 'blue' | 'cyan' | 'warm-gray' | 'purple' }> = {
  huy: { text: 'Đã hủy kỳ', tag: 'red' },
  co_kq: { text: 'Có kết quả', tag: 'green' },
  lech: { text: 'Nguồn đổi sau khi chốt', tag: 'magenta' },
  mo_cuoc: { text: 'Đang nhận cược', tag: 'blue' },
  dang_quay: { text: 'Đang quay', tag: 'cyan' },
  cho_nguon: { text: 'Chờ nguồn', tag: 'warm-gray' },
  qua_han: { text: 'Quá hạn, cần nhập tay', tag: 'red' },
};

export function DrawState({ s }: { s: string }) {
  const d = DRAW_STATE[s] ?? { text: s, tag: 'warm-gray' as const };
  return <Tag type={d.tag} size="sm">{d.text}</Tag>;
}

export const SOURCE_STATUS: Record<string, string> = {
  cho: 'Chờ nguồn', cho_on_dinh: 'Hai nguồn khớp, chờ đọc lại', da_nhan: 'Đã nhận từ hai nguồn', lech: 'Nguồn đổi sau khi nhận',
};
// ly do he A ghi (khong dau) -> chu cho nguoi van hanh
export const SOURCE_REASON: Record<string, string> = {
  'thieu minhngoc': 'Thiếu nguồn Minh Ngọc',
  'thieu xskt': 'Thiếu nguồn XSKT',
  'minhngoc chua du bang': 'Minh Ngọc chưa đủ bảng',
  'xskt chua du bang': 'XSKT chưa đủ bảng',
  'hai nguon lech': 'Hai nguồn lệch nhau',
  'hai nguon khop, cho doc lai': 'Hai nguồn khớp, chờ đọc lại',
  'hai nguon doi sang bang khac sau khi nhan': 'Hai nguồn đổi sang bảng khác sau khi nhận',
};

export const TICKET_STATUS: Record<string, { text: string; tag: 'blue' | 'green' | 'gray' | 'purple' }> = {
  cho: { text: 'Chờ kết quả', tag: 'blue' }, trung: { text: 'Trúng', tag: 'green' }, truot: { text: 'Trượt', tag: 'gray' }, hoan: { text: 'Đã hoàn', tag: 'purple' },
  BET: { text: 'Chờ kết quả', tag: 'blue' }, WIN: { text: 'Thắng', tag: 'green' }, LOSE: { text: 'Thua', tag: 'gray' },
};

export function TicketStatus({ s }: { s: string }) {
  const d = TICKET_STATUS[s] ?? { text: s, tag: 'gray' as const };
  return <Tag type={d.tag} size="sm">{d.text}</Tag>;
}

// today's draw day: the Vietnam lottery calendar (Vietnam time, whatever the CMS time zone is), yyyy-mm-dd
export const todayVn = () => new Date(Date.now() + 7 * 3600_000).toISOString().slice(0, 10);
export const pctOf = (x: number | null) => (x == null ? '-' : (Math.round(x * 1000) / 10).toString().replace('.', ',') + '%');
